module.exports = __webpack_public_path__ + "static/media/watermark.c89184ee.png";